import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Container } from '@scentregroup/ui'
import withMovies from '../../../containers/with-movies'
import containerStyle from '../../../components/container.scss'
import MovieFeature from '../../../components/movie-feature'
import movieCardsModule from '../../../helpers/movie-cards-module'
import whatsHappeningModule from '../../../helpers/whats-happening-module'
import RetailerUtilityBox from '../../../components/retailer-utility-box'
import { parseHostname } from '../../../helpers/url'
import pageLandingStyle from '../../../components/page-landing/index.scss'
import pagesHoc from '../../pages-hoc'
import pageLoadDataLayer, {
  mapMovieToPageLoadData,
} from '../../../helpers/analytics-utils/page-load-data-layer'
import withModules from '../../../containers/with-modules'
import Modules from '../../../components/modules'

export const MovieDetail = ({
  movie,
  movies,
  cinema,
  centre,
  date,
  modules,
  happenings,
  nextWeek,
}) => {
  useEffect(() => {
    pageLoadDataLayer(mapMovieToPageLoadData(movie, cinema), centre)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const store = {
    heading: 'Visit us',
    phoneNumber: cinema.telephoneNumber,
    link: cinema.websiteAddress,
    linkText: parseHostname(cinema.websiteAddress),
    location: cinema.physicalAddress,
    nearestLocation: cinema.landmarkDescription,
    status: cinema.status || 'Open',
    openHours: cinema.openHours,
  }
  const title = cinema.title || (cinema.retailer && cinema.retailer.title)
  const whatsHappeningEntries = happenings.filter(entry =>
    entry.storeIds.includes(cinema.sys.id)
  )

  return (
    <Container
      className={classNames(
        containerStyle.containerSpaced,
        containerStyle.allowForHeader
      )}
    >
      <MovieFeature movie={movie} date={date}>
        <RetailerUtilityBox className={pageLandingStyle.sideBar} {...store} />
      </MovieFeature>
      <Modules
        modules={[
          movieCardsModule(centre, 'Now showing', movies, nextWeek),
          ...(whatsHappeningEntries.length
            ? [whatsHappeningModule(whatsHappeningEntries, title, centre)]
            : []),
          ...modules,
        ]}
      />
    </Container>
  )
}

MovieDetail.propTypes = {
  movie: PropTypes.object.isRequired,
  movies: PropTypes.arrayOf(PropTypes.object),
  cinema: PropTypes.shape({
    telephoneNumber: PropTypes.string,
    websiteAddress: PropTypes.string,
    physicalAddress: PropTypes.string,
    landmarkDescription: PropTypes.string,
    status: PropTypes.string,
    openHours: PropTypes.shape({
      storeTradingSchedule: PropTypes.shape({
        tradingHours: PropTypes.array.isRequired,
        isStoreCentreLinked: PropTypes.bool.isRequired,
      }),
      centreTradingSchedule: PropTypes.shape({
        tradingHours: PropTypes.array.isRequired,
      }),
      timeZone: PropTypes.string.isRequired,
    }).isRequired,
    title: PropTypes.string,
    retailer: PropTypes.object,
    sys: PropTypes.object,
  }),
  centre: PropTypes.shape({
    slug: PropTypes.string.isRequired,
  }),
  date: PropTypes.string,
  templatePath: PropTypes.string,
  match: PropTypes.object,
  modules: PropTypes.array,
  happenings: PropTypes.array,
  nextWeek: PropTypes.array.isRequired,
}

MovieDetail.defaultProps = {
  happenings: [],
  modules: [],
}

export const getMetaData = ({ centre, movie }) => ({
  title: `${movie ? movie.title : ''} Movie Times at Westfield ${centre.title}`,
  description: `Find session times for ${movie.title} and watch the latest blockbusters on the big screen at Westfield ${centre.title}. See the latest release movies at Westfield ${centre.title}.`,
  schema: {},
})

export default withMovies(withModules(pagesHoc(MovieDetail, getMetaData)))
